import React from 'react';
import { WAREHOUSES_LIST } from '../lib/constants';
import { getStatusConfig } from '../lib/helpers';

// ==========================================================
// Component ตารางสต็อก
// ==========================================================
const StockTable = ({ lots, supplies, category, onUpdate, onDelete, onEditLot, onOpenTransfer, onNavigate }) => {
  const sortedLots = [...lots].sort((a, b) => new Date(a.exp_date) - new Date(b.exp_date));
  return (
    <div className="stock-table-container">
      {sortedLots.map(masterLot => {
        let lotItems = supplies.filter(s => s.master_id === masterLot.id);
        if (category === 'วัสดุคงทน' || category === 'หัวกรอ' || masterLot.is_set) {
            const consumableWarehouses = ["ห้องคลีนิก"]; 
            lotItems = lotItems.filter(s => !consumableWarehouses.includes(s.warehouse_name));
        }
        const lotTotal = lotItems.reduce((sum, s) => sum + (s.item_amount || 0), 0);
        const style = getStatusConfig(lotTotal, masterLot.exp_date);
        const isBelowLotMin = lotTotal < (masterLot.min_stock || 0); 
        
        const sList = lotItems.sort((a, b) => {
          const orderA = WAREHOUSES_LIST.find(w => w.name === a.warehouse_name)?.order || 99;
          const orderB = WAREHOUSES_LIST.find(w => w.name === b.warehouse_name)?.order || 99;
          return orderA - orderB;
        });

        let borderColor = style.bg;
        let bgColor = style.bg;
        if (masterLot.is_set) {
            borderColor = masterLot.category === 'หัวกรอ' ? '#f48fb1' : '#9b59b6';
            bgColor = masterLot.category === 'หัวกรอ' ? '#d81b60' : '#8e44ad';
        }

        return (
          <div key={masterLot.id} style={{ border: `2px solid ${borderColor}`, marginBottom: '15px', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
            <div style={{ background: bgColor, color: '#fff', padding: '8px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                <button onClick={() => onEditLot(masterLot)} style={{background:'white', color:'#333', border:'none', borderRadius:'4px', cursor:'pointer', fontSize:'0.82em', padding:'3px 8px', fontWeight: '600'}}>⚙️ แก้ไข</button>
                {onOpenTransfer && (
                  <button
                    type="button"
                    onClick={() => onOpenTransfer({ masterId: masterLot.id, itemName: masterLot.item_name, lotNumber: masterLot.lot_number })}
                    style={{
                      background: 'white',
                      color: '#0284c7',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '0.82em',
                      padding: '3px 8px',
                      fontWeight: '600',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '3px'
                    }}
                    title="โอนย้ายสต็อกสำหรับล็อตนี้"
                  >
                    🔄 โอนย้าย
                  </button>
                )}
                {onNavigate && category === 'วัสดุสิ้นเปลือง' && (
                  <button
                    type="button"
                    onClick={() => onNavigate('dispense-report', { mode: 'ledger', itemId: masterLot.id })}
                    style={{
                      background: 'white',
                      color: '#059669',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '0.82em',
                      padding: '3px 8px',
                      fontWeight: '600',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '3px'
                    }}
                    title="ดูบัญชีวัสดุสำหรับล็อตนี้"
                  >
                    📑 บัญชีวัสดุ
                  </button>
                )}
                <strong>{masterLot.is_set ? '📦 รหัสชุด:' : 'Lot:'}</strong> {masterLot.lot_number || '-'} 
                {!masterLot.is_set && category === 'วัสดุสิ้นเปลือง' && <span style={{color: '#f1c40f', fontWeight: '600'}}>| EXP: {masterLot.exp_date}</span>}
                {!masterLot.is_set && <span style={{ fontSize: '0.85em', color: '#fff', marginLeft: '5px' }}>[ขั้นต่ำ Lot: {masterLot.min_stock || 0}]</span>}
                {!masterLot.is_set && isBelowLotMin && <span style={{ fontSize: '0.75em', background: '#c0392b', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>⚠️ ต่ำกว่าขั้นต่ำ Lot</span>}
                {!masterLot.is_set && <span style={{ fontSize: '0.72em', border: '1px solid #fff', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>{style.label}</span>}
              </div>
              <button onClick={() => { if(window.confirm("ลบข้อมูลล็อต/ชุดนี้?")) onDelete(masterLot.id); }} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', fontSize: '1.1em', padding: '2px 6px' }} title="ลบล็อตนี้">🗑️</button>
            </div>
            
            {!masterLot.is_set && (masterLot.barcode || masterLot.company || masterLot.po_number || masterLot.delivery_note || masterLot.order_date || masterLot.receive_date || masterLot.approval_date || masterLot.price_per_unit > 0) && (
              <div style={{ padding: '10px 15px', background: '#f8f9fa', fontSize: '0.85em', color: '#444', borderBottom: '1px solid #ddd', display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                {masterLot.barcode && <div>🏭 <strong>ผู้ผลิต:</strong> {masterLot.barcode}</div>}
                {masterLot.company && <div>🏢 <strong>Supplier:</strong> {masterLot.company}</div>}
                {masterLot.price_per_unit > 0 && <div>💰 <strong>ราคา:</strong> {masterLot.price_per_unit} ฿/{masterLot.unit || 'ชิ้น'}</div>}
                {masterLot.order_date && <div>📅 <strong>วันที่สั่ง:</strong> {masterLot.order_date}</div>}
                {masterLot.approval_date && <div>✅ <strong>อนุมัติ:</strong> {masterLot.approval_date}</div>}
                {masterLot.receive_date && <div>📥 <strong>รับของ:</strong> {masterLot.receive_date}</div>}
                {masterLot.po_number && <div>📄 <strong>PO:</strong> {masterLot.po_number}</div>}
                {masterLot.delivery_note && <div>🧾 <strong>ใบส่ง:</strong> {masterLot.delivery_note}</div>}
              </div>
            )}

            <table style={{ width: '100%', fontSize: '0.9em', borderCollapse: 'collapse', background: '#fff' }}>
              <tbody>
                {sList.map(s => (
                  <tr key={s.id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '10px 14px', color: '#333' }}>{s.warehouse_name}</td>
                    <td style={{ textAlign: 'center', fontWeight: 'bold', padding: '10px 14px', color: '#111' }}>{s.item_amount} {masterLot.unit || ''}</td>
                    <td style={{ textAlign: 'right', paddingRight: '14px', whiteSpace: 'nowrap' }}>
                       <button
                         onClick={() => onUpdate(s.id, s.item_amount, 'increase', masterLot.item_name, s.warehouse_name)}
                         style={{
                           background: '#2ecc71',
                           color: '#ffffff',
                           border: 'none',
                           borderRadius: '6px',
                           padding: '5px 12px',
                           cursor: 'pointer',
                           fontWeight: 'bold',
                           fontSize: '1em',
                           boxShadow: '0 2px 4px rgba(46,204,113,0.3)',
                           transition: 'all 0.15s ease'
                         }}
                         title="เพิ่มจำนวน"
                       >+</button>
                       <button
                         onClick={() => onUpdate(s.id, s.item_amount, 'decrease', masterLot.item_name, s.warehouse_name)}
                         style={{
                           marginLeft: '8px',
                           background: '#e74c3c',
                           color: '#ffffff',
                           border: 'none',
                           borderRadius: '6px',
                           padding: '5px 12px',
                           cursor: 'pointer',
                           fontWeight: 'bold',
                           fontSize: '1em',
                           boxShadow: '0 2px 4px rgba(231,76,60,0.3)',
                           transition: 'all 0.15s ease'
                         }}
                         title="ลดจำนวน"
                       >-</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
};

export default StockTable;
